// base
import { createSlice } from '@reduxjs/toolkit';

// actions
import { CHART_DASHBOARD_SLICE_NAME } from '../actions';

// thunks
import { getProjectChartDashboard } from '../thunks';

// models
import { ChartDashboardState } from '../models';

// libraries
import dayjs from 'dayjs';

// initialState
const initialState: ChartDashboardState = {
  updateTime: null,
  pjtInfo: undefined,
  weather: undefined,
  todayEntry: {
    totalWorker: 0,
    currentWorker: 0,
    companyEntryList: []
  },
  weeklyEntry: {
    thisWeek: [],
    totalWorkers: 0,
    lastWeek: []
  },
  todayWorkStatus: {
    total: {
      sum: { tbmCount: 0, workerCount: 0 },
      completed: { tbmCount: 0, workerCount: 0 },
      working: { tbmCount: 0, workerCount: 0 },
      scheduled: { tbmCount: 0, workerCount: 0 }
    },
    general: {
      sum: { tbmCount: 0, workerCount: 0 },
      completed: { tbmCount: 0, workerCount: 0 },
      working: { tbmCount: 0, workerCount: 0 },
      scheduled: { tbmCount: 0, workerCount: 0 }
    },
    highRisk: {
      sum: { tbmCount: 0, workerCount: 0 },
      completed: { tbmCount: 0, workerCount: 0 },
      working: { tbmCount: 0, workerCount: 0 },
      scheduled: { tbmCount: 0, workerCount: 0 }
    }
  },
  workingManpower: {
    totalWorker: 0,
    companyEntryList: []
  },
  raWorkRisk: {
    low: 0,
    moderate: 0,
    high: 0,
    extreme: 0
  },
  raApproval: {
    issuedCount: 0,
    ongoingCount: 0,
    approvedCount: 0,
    deniedCount: 0,
    disciplineStatus: {},
    heatMap: {
      rareList: [],
      possibleList: [],
      likelyList: [],
      oftenList: [],
      frequentList: []
    }
  },
  mptwStatus: {
    issuedCount: 0,
    ongoingCount: 0,
    approvedCount: 0,
    deniedCount: 0,
    disciplineStatus: {},
    heatMap: {
      rareList: [],
      possibleList: [],
      likelyList: [],
      oftenList: [],
      frequentList: []
    }
  },
  ncStatus: {
    issuedCount: 0,
    ongoingCount: 0,
    approvedCount: 0,
    deniedCount: 0,
    disciplineStatus: {},
    heatMap: {
      rareList: [],
      possibleList: [],
      likelyList: [],
      oftenList: [],
      frequentList: []
    }
  },
  equipmentDash: {
    countData: {
      registeredTotalCount: 0,
      rentCount: {
        available: 0,
        inUse: 0,
        maintenance: 0
      },
      inspectionCount: {
        finishCount: 0,
        requiredCount: 0,
        argentCount: 0
      }
    }
  }
};

// createSlice
const chartDashboardSlice = createSlice({
  name: CHART_DASHBOARD_SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) =>
    builder.addCase(getProjectChartDashboard.fulfilled, (state, { payload }) => {
      const { resultObject } = payload;

      const dubaiTime = dayjs().utcOffset(4);

      state.pjtInfo = resultObject.pjtInfo;
      state.weather = resultObject.weather;
      state.todayEntry = resultObject.todayEntry;
      state.todayWorkStatus = resultObject.todayWorkStatus;
      state.weeklyEntry = resultObject.weeklyEntry;
      state.workingManpower = resultObject.workingManpower;
      state.raApproval = resultObject.raApproval;
      state.raWorkRisk = resultObject.raWorkRisk;
      state.mptwStatus = resultObject.mptwStatus;
      state.ncStatus = resultObject.ncStatus;
      state.updateTime = dubaiTime.format('hh:mm:ss A');
      state.equipmentDash = resultObject.equipmentDash;
    })
});

export const chartDashboard = chartDashboardSlice.name;
export const chartDashboardReducer = chartDashboardSlice.reducer;
export const chartDashboardActions = chartDashboardSlice.actions;
export default chartDashboardSlice.reducer;
